import type React from 'react';
import styles from './QuickCheckout.module.scss';
import ContinueShopping from '../PriceOverview/ContinueShopping';
import FormatPrice from '../../../general/Format/FormatPrice';
import Translation from '../../../general/Translation/Translation';
import ContinueToCheckout from '../Cta/ContinueToCheckout';
import { useTypedSelector } from '../../Store/connectors';
import type { Price } from '../../../../ssr/src/Outlet/ShoppingCart/ShoppingCartSchema';

export interface QuickCheckoutProps {
  total: Price;
}

const QuickCheckout: React.FC<QuickCheckoutProps> = ({ total }) => {
  const isAllowedToProceedToCheckout = useTypedSelector(
    ({ ui }) => ui.isAllowedToProceedToCheckout,
  );
  const cartContainsAlcohol = useTypedSelector(
    ({ cartItems }) => cartItems.cartContainsAlcohol,
  );
  const hideQuickPaymentButton = useTypedSelector(
    ({ metaData }) => metaData.hideQuickPaymentButton,
  );

  return (
    <div className={styles.QuickCheckout}>
      <ContinueShopping showOnMobile />
      <div>
        <h2 className="h3">
          <Translation
            pageString="checkout"
            stringId="shoppingcart-title"
          />
        </h2>
        {!hideQuickPaymentButton && (
          <p className="mt-2 mb-2">
            <FormatPrice price={total} />
          </p>
        )}
      </div>
      {!hideQuickPaymentButton &&
        isAllowedToProceedToCheckout &&
        !cartContainsAlcohol && <ContinueToCheckout />}
    </div>
  );
};

export default QuickCheckout;
